const EU_ISO = new Set([
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
  'IS',
  'LI',
  'NO',
  'CH',
  'GB',
]);

export const guessTz = (): string | null => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
  } catch {
    return null;
  }
};

export const isEUTz = (tz = guessTz()): boolean => !!tz && (tz.startsWith('Europe/') || tz === 'GMT' || tz === 'UTC');

export const isEUCountry = (cc?: string | null): boolean => !!cc && EU_ISO.has(cc.toUpperCase());

export const isEUVisitor = (): boolean => {
  const cc = typeof document !== 'undefined' ? document.documentElement.getAttribute('data-cc') : null;
  if (isEUCountry(cc)) {
    return true;
  }

  return isEUTz();
};
